export default __webpack_public_path__ + "static/media/Gloves of Tribulation.221ba902.jpg";